import React from "react";
import { withRouter } from "react-router-dom";
import HUBContext from "../services/HUBContext";
import LoaderSpinner from "../helpers/LoaderSpinner";
import { withStyles } from "@material-ui/core";

const styles = (theme) => ({
  centerContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "450px",
  },
});
class CompanyParamProvider extends React.Component {
  state = {
    isReady: false,
  };

  componentDidMount() {
    const { setCompany } = this.context;
    const { cid } = this.props?.match?.params;
    if (!cid) return;

    if (typeof setCompany === "function") {
      setCompany(cid);
      this.setState({ isReady: true });
    }
  }

  render() {
    const { isReady } = this.state;
    const { classes } = this.props;

    if (!isReady) {
      return (
        <div className={classes.centerContainer}>
          <LoaderSpinner />
        </div>
      );
    }

    return this.props.children;
  }
}

CompanyParamProvider.contextType = HUBContext;
export default withStyles(styles)(withRouter(CompanyParamProvider));
